/** *
 *  erp列表
 */

import Main from '@components/main/main'

const erpChargebackList = {
  path: '/erpChargebackList',
  component: Main,
  redirect: '/erpChargebackList',
  children: [{
    name: 'erpChargebackList',
    path: '/erpChargebackList',
    component: () => import ('@/pages/erpChargebackList/pages/list'),
    meta: {
      auth: true,
      title: 'erp推单列表'
    }
    //   },
    //   {
    // name: '',
    // path: '/erpChargebackList/recharge',
    // component: () => import ('@/pages/erpChargebackList/pages/recharge'),
    // meta: {
    //   auth: true,
    //   title: 'erp推单详情'
    // }
  }
  ]
}

export default erpChargebackList




// WEBPACK FOOTER //
// ./src/pages/erpChargebackList/index.js